import { useState } from 'react';

export default function Microcourses() {
  const [activeCategory, setActiveCategory] = useState('AI & FUTURE SKILLS');

  const categories = [
    {
      label: 'AI & FUTURE SKILLS',
      courses: [
        {
          title: 'AI Productivity Boost',
          description: 'Use AI tools to accelerate your workflow.',
          duration: '45 min',
          badge: 'AI Badge',
          microcredential: 'AI Foundations',
          icon: 'ri-robot-line',
          image: 'https://public.readdy.ai/ai/img_res/e73da1f37bbd7ae4b9dc5dff28548478.jpg',
        },
        {
          title: 'Mastering AI Prompts (Beginner)',
          description: 'Learn powerful prompt structures for better outputs.',
          duration: '40 min',
          badge: 'AI Badge',
          microcredential: 'AI Foundations',
          icon: 'ri-chat-3-line',
          image: 'https://readdy.ai/api/search-image?query=young%20student%20typing%20AI%20prompts%20on%20laptop%20screen%20showing%20chatbot%20interface%20and%20prompt%20engineering%20with%20clean%20modern%20workspace%20bright%20lighting%20and%20focused%20learning%20environment%20demonstrating%20artificial%20intelligence%20interaction&width=400&height=300&seq=mastering-ai-prompts&orientation=landscape',
        },
        {
          title: 'AI for Smarter Research',
          description: 'Find and summarize information instantly with AI.',
          duration: '45 min',
          badge: 'AI Badge',
          microcredential: 'AI Foundations',
          icon: 'ri-search-line',
          image: 'https://readdy.ai/api/search-image?query=young%20researcher%20student%20using%20laptop%20with%20AI%20research%20tools%20analyzing%20data%20and%20summarizing%20information%20in%20bright%20modern%20library%20workspace%20with%20digital%20screens%20showing%20smart%20research%20technology%20and%20knowledge%20discovery&width=400&height=300&seq=ai-smarter-research&orientation=landscape',
        },
        {
          title: 'Build Your First AI Assistant',
          description: 'Create a simple personal AI using templates and no-code tools.',
          duration: '60 min',
          badge: 'AI Badge',
          microcredential: 'AI Foundations',
          icon: 'ri-tools-line',
          image: 'https://readdy.ai/api/search-image?query=young%20developer%20student%20building%20no-code%20AI%20assistant%20application%20on%20computer%20screen%20with%20drag-and-drop%20interface%20templates%20in%20bright%20modern%20workspace%20showing%20app%20development%20and%20artificial%20intelligence%20creation&width=400&height=300&seq=build-ai-assistant&orientation=landscape',
        },
      ],
    },
    {
      label: 'DIGITAL CREATION',
      courses: [
        {
          title: 'Design an Impactful Presentation',
          description: 'Create slides people remember.',
          duration: '45 min',
          badge: 'Design Badge',
          microcredential: 'Digital Communication',
          icon: 'ri-slideshow-line',
          image: 'https://readdy.ai/api/search-image?query=young%20creative%20professional%20designing%20impactful%20presentation%20slides%20on%20large%20screen%20with%20modern%20design%20tools%20in%20bright%20collaborative%20workspace%20showing%20visual%20storytelling%20and%20professional%20slide%20deck%20creation&width=400&height=300&seq=impactful-presentation&orientation=landscape',
        },
        {
          title: 'Build a Personal Portfolio in 45 Min',
          description: 'Create an online portfolio using AI templates.',
          duration: '45 min',
          badge: 'Design Badge',
          microcredential: 'Digital Communication',
          icon: 'ri-layout-line',
          image: 'https://readdy.ai/api/search-image?query=young%20student%20building%20personal%20portfolio%20website%20on%20computer%20using%20AI%20templates%20and%20modern%20design%20tools%20in%20bright%20workspace%20showing%20web%20design%20interface%20and%20creative%20digital%20portfolio%20creation&width=400&height=300&seq=personal-portfolio&orientation=landscape',
        },
        {
          title: 'Storytelling for Work & School',
          description: 'Craft stories that connect and inspire.',
          duration: '40 min',
          badge: 'Communication Badge',
          microcredential: 'Digital Communication',
          icon: 'ri-book-open-line',
          image: 'https://readdy.ai/api/search-image?query=young%20diverse%20students%20in%20storytelling%20workshop%20sharing%20narratives%20and%20crafting%20compelling%20stories%20in%20bright%20modern%20classroom%20with%20collaborative%20learning%20environment%20showing%20communication%20and%20creative%20expression&width=400&height=300&seq=storytelling-workshop&orientation=landscape',
        },
        {
          title: 'Create a Mini Website with AI',
          description: 'Launch a simple landing page without coding.',
          duration: '50 min',
          badge: 'Web Badge',
          microcredential: 'Digital Communication',
          icon: 'ri-window-line',
          image: 'https://readdy.ai/api/search-image?query=young%20student%20creating%20landing%20page%20website%20using%20AI%20no-code%20tools%20on%20laptop%20screen%20showing%20modern%20web%20design%20interface%20and%20simple%20website%20builder%20in%20bright%20workspace%20with%20digital%20creation&width=400&height=300&seq=mini-website-ai&orientation=landscape',
        },
      ],
    },
    {
      label: 'CAREER DISCOVERY',
      courses: [
        {
          title: 'Find Your Career Theme',
          description: 'Identify strengths and direction for your future.',
          duration: '45 min',
          badge: 'Career Badge',
          microcredential: 'Career Discovery',
          icon: 'ri-compass-line',
          image: 'https://readdy.ai/api/search-image?query=young%20thoughtful%20student%20planning%20career%20path%20with%20notebook%20and%20laptop%20in%20bright%20modern%20workspace%20showing%20career%20exploration%20self-reflection%20and%20future%20planning%20with%20positive%20mindset%20and%20determination&width=400&height=300&seq=career-theme&orientation=landscape',
        },
        {
          title: 'Make Better Career Decisions',
          description: 'A simple method for choosing your next step.',
          duration: '45 min',
          badge: 'Career Badge',
          microcredential: 'Career Discovery',
          icon: 'ri-route-line',
          image: 'https://readdy.ai/api/search-image?query=young%20professional%20student%20choosing%20career%20path%20with%20decision-making%20framework%20and%20planning%20tools%20in%20bright%20workspace%20showing%20career%20guidance%20strategic%20thinking%20and%20confident%20future%20direction&width=400&height=300&seq=career-decisions&orientation=landscape',
        },
        {
          title: 'Build Your Confidence Loop',
          description: 'Micro-habits for clarity, consistency and growth.',
          duration: '30 min',
          badge: 'Growth Badge',
          microcredential: 'Career Discovery',
          icon: 'ri-refresh-line',
          image: 'https://readdy.ai/api/search-image?query=confident%20young%20student%20in%20personal%20development%20workshop%20building%20positive%20habits%20and%20self-growth%20in%20bright%20inspiring%20space%20showing%20empowerment%20mindfulness%20and%20consistent%20progress%20toward%20goals&width=400&height=300&seq=confidence-loop&orientation=landscape',
        },
        {
          title: 'Craft Your 3-Minute Personal Story',
          description: 'Tell your story with clarity and impact.',
          duration: '35 min',
          badge: 'Communication Badge',
          microcredential: 'Career Discovery',
          icon: 'ri-mic-line',
          image: 'https://readdy.ai/api/search-image?query=young%20confident%20student%20presenting%20personal%20story%20and%20speaking%20to%20audience%20in%20bright%20modern%20space%20showing%20public%20speaking%20communication%20skills%20and%20authentic%20storytelling%20with%20engaging%20presence&width=400&height=300&seq=personal-story&orientation=landscape',
        },
      ],
    },
    {
      label: 'BUSINESS ESSENTIALS',
      courses: [
        {
          title: 'Business Models in 45 Min',
          description: 'Understand how companies create value.',
          duration: '45 min',
          badge: 'Business Badge',
          microcredential: 'Business Essentials',
          icon: 'ri-pie-chart-line',
          image: 'https://readdy.ai/api/search-image?query=young%20business%20students%20analyzing%20business%20models%20on%20whiteboard%20with%20strategy%20diagrams%20and%20value%20creation%20frameworks%20in%20bright%20modern%20classroom%20showing%20entrepreneurial%20learning%20and%20business%20fundamentals&width=400&height=300&seq=business-models&orientation=landscape',
        },
        {
          title: 'Launch a Simple Business Idea',
          description: 'Create and validate an idea quickly.',
          duration: '50 min',
          badge: 'Entrepreneur Badge',
          microcredential: 'Business Essentials',
          icon: 'ri-rocket-line',
          image: 'https://readdy.ai/api/search-image?query=young%20diverse%20startup%20team%20brainstorming%20business%20idea%20with%20sticky%20notes%20and%20laptops%20in%20bright%20collaborative%20workspace%20showing%20entrepreneurship%20innovation%20and%20idea%20validation%20process&width=400&height=300&seq=launch-business-idea&orientation=landscape',
        },
        {
          title: 'Growth Basics (Beginner)',
          description: 'Learn how modern companies scale.',
          duration: '40 min',
          badge: 'Growth Badge',
          microcredential: 'Business Essentials',
          icon: 'ri-line-chart-line',
          image: 'https://readdy.ai/api/search-image?query=young%20professionals%20in%20growth%20analytics%20workshop%20studying%20company%20scaling%20strategies%20with%20data%20charts%20and%20metrics%20on%20screens%20in%20bright%20modern%20space%20showing%20business%20growth%20fundamentals&width=400&height=300&seq=growth-basics&orientation=landscape',
        },
        {
          title: 'Marketing for Non-Marketers',
          description: 'Learn persuasion and audience fundamentals.',
          duration: '45 min',
          badge: 'Marketing Badge',
          microcredential: 'Business Essentials',
          icon: 'ri-megaphone-line',
          image: 'https://readdy.ai/api/search-image?query=young%20diverse%20team%20in%20marketing%20planning%20session%20with%20campaign%20ideas%20and%20audience%20strategy%20boards%20in%20bright%20modern%20workspace%20showing%20marketing%20fundamentals%20persuasion%20and%20creative%20communication&width=400&height=300&seq=marketing-non-marketers&orientation=landscape',
        },
      ],
    },
    {
      label: 'CREATIVE THINKING',
      courses: [
        {
          title: 'Creative Thinking Micro-Exercises',
          description: 'Unlock creativity with simple techniques.',
          duration: '30 min',
          badge: 'Creative Badge',
          microcredential: 'Creative Thinking',
          icon: 'ri-lightbulb-flash-line',
          image: 'https://readdy.ai/api/search-image?query=young%20diverse%20students%20in%20creative%20thinking%20workshop%20doing%20brainstorming%20exercises%20with%20colorful%20materials%20in%20bright%20inspiring%20space%20showing%20innovation%20imagination%20and%20creative%20problem-solving%20techniques&width=400&height=300&seq=creative-exercises&orientation=landscape',
        },
        {
          title: 'Brainstorm Better with AI',
          description: 'Generate ideas rapidly with AI assistance.',
          duration: '40 min',
          badge: 'AI Badge',
          microcredential: 'Creative Thinking',
          icon: 'ri-brain-line',
          image: 'https://readdy.ai/api/search-image?query=young%20creative%20professional%20using%20AI%20brainstorming%20tools%20on%20laptop%20generating%20innovative%20ideas%20with%20digital%20mind%20maps%20in%20bright%20modern%20workspace%20showing%20AI-assisted%20creativity%20and%20rapid%20ideation&width=400&height=300&seq=brainstorm-ai&orientation=landscape',
        },
        {
          title: 'Rapid Prototyping for Beginners',
          description: 'Turn ideas into simple prototypes fast.',
          duration: '50 min',
          badge: 'Design Badge',
          microcredential: 'Creative Thinking',
          icon: 'ri-pencil-ruler-line',
          image: 'https://readdy.ai/api/search-image?query=young%20students%20in%20prototyping%20session%20building%20simple%20product%20prototypes%20with%20sketches%20and%20digital%20tools%20in%20bright%20collaborative%20workspace%20showing%20design%20thinking%20and%20rapid%20iteration%20process&width=400&height=300&seq=rapid-prototyping&orientation=landscape',
        },
        {
          title: 'Solve Problems with First Principles',
          description: 'Break down challenges using a clear framework.',
          duration: '45 min',
          badge: 'Problem Solver Badge',
          microcredential: 'Creative Thinking',
          icon: 'ri-puzzle-line',
          image: 'https://readdy.ai/api/search-image?query=young%20diverse%20team%20solving%20complex%20problems%20together%20with%20whiteboard%20frameworks%20and%20analytical%20thinking%20in%20bright%20modern%20workspace%20showing%20first%20principles%20methodology%20and%20collaborative%20problem-solving&width=400&height=300&seq=first-principles&orientation=landscape',
        },
      ],
    },
    {
      label: 'LEADERSHIP FOUNDATIONS',
      courses: [
        {
          title: 'Lead a Team Meeting',
          description: 'Facilitate clarity and results.',
          duration: '45 min',
          badge: 'Leadership Badge',
          microcredential: 'Leadership Foundations',
          icon: 'ri-team-line',
          image: 'https://readdy.ai/api/search-image?query=young%20confident%20leader%20facilitating%20team%20meeting%20with%20diverse%20group%20in%20bright%20modern%20conference%20room%20showing%20leadership%20communication%20collaboration%20and%20effective%20meeting%20management%20skills&width=400&height=300&seq=lead-team-meeting&orientation=landscape',
        },
        {
          title: 'Give Feedback That Helps',
          description: 'Deliver constructive feedback with confidence.',
          duration: '40 min',
          badge: 'Leadership Badge',
          microcredential: 'Leadership Foundations',
          icon: 'ri-chat-check-line',
          image: 'https://readdy.ai/api/search-image?query=young%20professional%20giving%20constructive%20feedback%20in%20one-on-one%20coaching%20session%20in%20bright%20modern%20workspace%20showing%20empathetic%20communication%20leadership%20mentoring%20and%20supportive%20guidance&width=400&height=300&seq=give-feedback&orientation=landscape',
        },
        {
          title: 'Influence Without Authority',
          description: 'Lead through ideas and collaboration.',
          duration: '45 min',
          badge: 'Leadership Badge',
          microcredential: 'Leadership Foundations',
          icon: 'ri-hand-heart-line',
          image: 'https://readdy.ai/api/search-image?query=young%20professional%20influencing%20team%20through%20collaborative%20ideas%20and%20persuasion%20in%20bright%20modern%20workspace%20showing%20leadership%20without%20authority%20teamwork%20and%20positive%20influence%20skills&width=400&height=300&seq=influence-authority&orientation=landscape',
        },
        {
          title: 'Build Trust Quickly',
          description: 'Create connection and credibility fast.',
          duration: '35 min',
          badge: 'Leadership Badge',
          microcredential: 'Leadership Foundations',
          icon: 'ri-shield-check-line',
          image: 'https://readdy.ai/api/search-image?query=young%20diverse%20professionals%20building%20trust%20and%20connection%20through%20authentic%20communication%20in%20bright%20collaborative%20workspace%20showing%20credibility%20relationship-building%20and%20team%20bonding&width=400&height=300&seq=build-trust&orientation=landscape',
        },
      ],
    },
  ];

  const activeCategoryData = categories.find(cat => cat.label === activeCategory);

  return (
    <section id="microcourses" className="py-28 px-6 lg:px-12 relative overflow-hidden">
      {/* Animated gradient background - same as Hero */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#304FFE]/[0.08] via-transparent to-[#7C4DFF]/[0.08]">
        <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      </div>

      {/* Floating decorative elements - same as Hero */}
      <div className="absolute top-1/4 right-[10%] w-64 h-64 bg-gradient-to-br from-[#304FFE]/20 to-[#7C4DFF]/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-1/4 left-[15%] w-48 h-48 bg-gradient-to-br from-[#7C4DFF]/15 to-[#304FFE]/15 rounded-full blur-3xl animate-pulse delay-1000"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16">
          <div>
            <h2 className="text-5xl lg:text-6xl font-bold text-[#1A1F36] mb-4">
              Learn something new today
            </h2>
            <p className="text-xl text-gray-600 max-w-xl">
              Short, practical microcourses designed to help you grow quickly and earn your first badges.
            </p>
          </div>
          <a
            href="#all-courses"
            className="mt-6 lg:mt-0 text-[#7C4DFF] font-medium flex items-center gap-2 hover:gap-3 transition-all group cursor-pointer whitespace-nowrap"
          >
            Browse All Microcourses
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>

        {/* Category Filter */}
        <div className="mb-12 flex flex-wrap gap-3">
          {categories.map((category) => (
            <button
              key={category.label}
              onClick={() => setActiveCategory(category.label)}
              className={`px-6 py-3 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === category.label
                  ? 'bg-gradient-to-r from-[#304FFE] to-[#7C4DFF] text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-gray-50 shadow-md'
              }`}
            >
              {category.label}
            </button>
          ))}
        </div>

        {/* Course Cards Grid - Only 2 rows (8 courses) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {activeCategoryData?.courses.map((course, index) => (
            <div
              key={index}
              className="group cursor-pointer hover:-translate-y-2 transition-all duration-300"
            >
              <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-shadow h-full flex flex-col border border-gray-100">
                {/* Image Area with Purple/Blue Overlay */}
                <div className="aspect-[4/3] relative overflow-hidden w-full h-56">
                  <img
                    src={course.image}
                    alt={course.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-br from-[#304FFE]/30 via-[#7C4DFF]/25 to-[#304FFE]/20"></div>
                </div>

                {/* Content Area */}
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="text-xl font-bold text-[#1A1F36] mb-2 leading-tight">
                    {course.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-5 leading-relaxed">
                    {course.description}
                  </p>

                  {/* Badge Info */}
                  <div className="flex items-center gap-2 mb-2 text-gray-700">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-award-line text-base text-[#7C4DFF]"></i>
                    </div>
                    <span className="text-sm font-medium">Earn 1 Badge</span>
                  </div>

                  {/* Microcredential Info */}
                  <div className="flex items-start gap-2 mb-3 text-gray-700">
                    <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                      <i className="ri-star-line text-base text-[#FFA726]"></i>
                    </div>
                    <span className="text-sm leading-tight">
                      Counts toward Microcredential: {course.microcredential}
                    </span>
                  </div>

                  {/* Duration */}
                  <div className="flex items-center gap-2 mb-5 text-gray-600">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-time-line text-base"></i>
                    </div>
                    <span className="text-sm">{course.duration}</span>
                  </div>

                  {/* CTA Button */}
                  <button className="mt-auto w-full px-5 py-3.5 bg-gradient-to-r from-[#304FFE] to-[#7C4DFF] text-white text-sm font-semibold rounded-full hover:shadow-xl hover:scale-105 transition-all whitespace-nowrap cursor-pointer">
                    Earn This Badge
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
